import { render, staticRenderFns } from "./ColumnContentContext.vue?vue&type=template&id=0bea80c3&scoped=true"
import script from "./ColumnContentContext.vue?vue&type=script&lang=js"
export * from "./ColumnContentContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea80c3",
  null
  
)

export default component.exports